import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  customerDataValue: null,
};

const customerDetailsSlice = createSlice({
  name: 'customerDetails',
  initialState,
  reducers: {
    setCustomerDataValue: (state, action) => {
      state.customerDataValue = action.payload;
    },
  },
});

export const {setCustomerDataValue} = customerDetailsSlice.actions;

export default customerDetailsSlice.reducer;
